import { render } from "./copyright_footer.vue?vue&type=template&id=7ecb7763&scoped=true"
import script from "./copyright_footer.vue?vue&type=script&lang=js"
export * from "./copyright_footer.vue?vue&type=script&lang=js"

import "./copyright_footer.vue?vue&type=style&index=0&id=7ecb7763&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ecb7763"]])

export default __exports__